import { Box, Sheet, Stack } from "@mui/joy";
import { TaskEditorBlock } from "pages/task-editor/utils/taskEditorUtils";
import PreviewDescription from "./PreviewDescription";
import PreviewAction from "./PreviewAction";
import { PreviewSessionApi } from "./usePreviewSession";

interface PreviewBlockProps {
  block: TaskEditorBlock;
  blockSequence: number; // 1-based
  mode: "static" | "interactive";
  session: PreviewSessionApi;
  viewerMode: "patient" | "coach";
  totalBlocks: number;
}

// 기본 (body) 블록은 흰색 sheet + 둥근 모서리. header 블록은 v1 의 Header1 처럼
// transparent 배경 + 좁은 padding 으로 렌더하고, 두 번째 이후 등장하면 위쪽
// 여백을 더해 본문과의 간격을 살린다.
function PreviewBlock({
  block,
  blockSequence,
  mode,
  session,
  viewerMode,
  totalBlocks,
}: PreviewBlockProps) {
  const isHeader = block.type === "header";
  return (
    <Sheet
      sx={
        isHeader
          ? {
              backgroundColor: "transparent",
              py: "12px",
              pl: "10px",
              ...(blockSequence > 1 && { pt: "24px" }),
            }
          : {
              backgroundColor: "white",
              borderRadius: "12px",
              px: "20px",
              py: "16px",
            }
      }
    >
      <Stack spacing="12px">
        {block.description.map((component, i) => (
          <PreviewDescription key={i} component={component} />
        ))}
        {block.action && (
          <Box sx={{ mt: "8px" }}>
            <PreviewAction
              action={block.action}
              blockIndex={blockSequence - 1}
              blockSequence={blockSequence}
              mode={mode}
              session={session}
              viewerMode={viewerMode}
              totalBlocks={totalBlocks}
            />
          </Box>
        )}
      </Stack>
    </Sheet>
  );
}

export default PreviewBlock;
